import Levenshtein from 'levenshtein';

const jsdiff = require('diff');

function sanitizeInput(string) {
  let sanitized = string.trim()
    .toLowerCase();
  sanitized = sanitized.replace(/[｡。！？'‘’“”";:,./?\\-]/g, '');
  return sanitized;
}

const scoring = {
  getTotalScore(original = '', transcript = '', confidence = 0) {
    const originalSanitized = sanitizeInput(original);
    const transcriptSanitized = sanitizeInput(transcript);

    if (originalSanitized.length === 0 || transcriptSanitized.length === 0) {
      return 0;
    }

    const l = new Levenshtein(originalSanitized, transcriptSanitized);
    let score = 100 - ((l.distance / originalSanitized.length) * 100);
    score *= confidence;
    score = score.toFixed(2);

    if (score < 0) {
      score = 0;
    }
    return score;
  },
  getTotalScoreAsia(original = '', transcript = '') {
    let right = 0;
    let score = 0;

    const originalSanitized = sanitizeInput(original);
    const transcriptSanitized = sanitizeInput(transcript);

    if (originalSanitized.length === 0 || transcriptSanitized.length === 0) {
      return [0];
    }
    const diff = jsdiff.diffChars(originalSanitized, transcriptSanitized);

    const originalWords = originalSanitized.split('');

    diff.forEach((part) => {
      if (!part.added && !part.removed) {
        right += part.count;
      }
    });

    score = (right / (originalWords.length * 100)) - (transcript.length - originalWords.length);

    return score;
  },
  getScoreByWord(original = '', transcript = '', score = 0, confidence = 0) {
    const originalSanitized = sanitizeInput(original);
    const transcriptSanitized = sanitizeInput(transcript);

    if (originalSanitized.length === 0 || transcriptSanitized.length === 0) {
      return [0];
    }
    const lev = [];
    const scoredWords = [];
    const diff = jsdiff.diffWordsWithSpace(originalSanitized, transcriptSanitized);
    let originalWords = originalSanitized.split(' ');
    const pos = 0;
    diff.forEach((part, j) => {
      let prev = {};
      let newWordWords = part.value.split(' ');
      newWordWords = newWordWords.filter(v => v !== '');
      if (!part.removed) {
        if (part.added) {
          if (j > 0) {
            prev = diff[j - 1];
          } else {
            prev.removed = false;
          }
          for (let i = 0; i < newWordWords.length; i++) {
            if (prev.removed) {
              originalWords = prev.value.split(' ');
              originalWords = originalWords.filter(v => v !== '');
              if (typeof originalWords[i] !== 'undefined') {
                lev[i] = new Levenshtein(originalWords[pos], newWordWords[i]);
                let scoreTemp = 100 - ((lev[i].distance / originalWords[i].length) * 100);
                scoreTemp *= confidence;
                scoredWords.push(scoreTemp);
              } else {
                scoredWords.push(0);
              }
            } else {
              scoredWords.push(0);
            }
          }
        } else {
          for (let i = 0; i < newWordWords.length; i++) {
            scoredWords.push(100 * confidence);
          }
        }
      }
    });
    for (let i = 0; i < scoredWords.length; i++) {
      if (scoredWords[i] < 0) {
        scoredWords[i] = 0;
      }
    }
    return scoredWords;
  },
  getScoreByWordAsia(original = '', transcript = '') {
    const originalSanitized = sanitizeInput(original);
    const transcriptSanitized = sanitizeInput(transcript);

    if (originalSanitized.length === 0 || transcriptSanitized.length === 0) {
      return [0];
    }

    const scoredWords = [];
    const diff = jsdiff.diffChars(originalSanitized, transcriptSanitized);

    diff.forEach((part) => {
      let newWordWords = part.value.split('');
      newWordWords = newWordWords.filter(v => v !== '');
      if (!part.removed) {
        if (part.added) {
          for (let i = 0; i < newWordWords.length; i++) {
            scoredWords.push(0);
          }
        } else {
          for (let i = 0; i < newWordWords.length; i++) {
            scoredWords.push(100);
          }
        }
      }
    });
    for (let i = 0; i < scoredWords.length; i++) {
      if (scoredWords[i] < 0) {
        scoredWords[i] = 0;
      }
    }
    return scoredWords;
  },
};

module.exports = scoring;



// WEBPACK FOOTER //
// ./src/modules/scoring.js